<template>
  <div class="BookDeatilStyle">
    <top-component></top-component>
    <div class="BookContainer">
      <div class="DivOne">
        <div v-if="dataObj.imageUrl" class="leftImg">
          <img :src="dataObj.imageUrl" alt="">
        </div>
        <div v-else class="leftImgDiv">
          <img src="../../assets/images/shang-pin.jpg" alt="">
        </div>
        <div class="rightBook">
          <div class="booktitle">{{dataObj.title}}&emsp;</div>
          <div class="bookauthor">{{dataObj.topic}}</div>
          <div class="bookauthor">{{dataObj.publisher}}</div>
          <!-- <div class="bookPrice">
            ￥{{dataObj.price}}
          </div> -->
            
          <div style="color:#ff3e3e;font-size:12px;">如需试用请联系我们公司驻当地分公司业务人员</div>
          <!-- <div class="tip-wrap">
            <div class="BookButton" @click="AddShopCar">
              <span class="iconfont iconcart"></span>&emsp;
              <span ref="caigouTitle">加入购物车</span>
            </div>
            <div class="m-tip">如需试用请联系我们公司驻当地分公司业务人员</div>
          </div> -->
        </div>
      </div>
      <div class="DiveThree">
        <div class="DivTwoTitle" ref="neirongTitle">简介</div>
        <div class="DivThreeContainer">
          {{dataObj.describes}}
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponentcopy.vue'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import { actionsave, actionbyId, selectMacrByGoodsId,shoppingCartnum } from '@/api/pages'
  import { Bookactionsearch } from '@/api/authority'
  export default {
    name: 'BookDeatil',
    data() {
      return {
        // 周边推荐
        dataObj: {
          title: '',
          topic: '',
          publisher: '',
          imageUrl: ''
        }
      }
    },
    mounted() {
    //   console.log(Cookies.get('LookPubgoodsIdDetaildataID'))
      this.GoodsDetail(this.$route.params.goodsId)
    },
    computed: {},
    methods: {
      // 商品信息
      GoodsDetail(goodsId) {
        var obj = {
          goodsId: goodsId
        }
        actionbyId(obj).then(response => {
        //   console.log(response.data)
          this.dataObj = response.data.unionGood
        })
      },
      // 添加购物车
      AddShopCar() {
        let vm = this;
        if (Cookies.get('token')) {
          var obj = {
            goodsId: vm.dataObj.goodsId,
            gid: vm.dataObj.gid,
            userId: Cookies.get('UserID'),
            amount: 1,
            isAddCart: 1 // 0代表从计数器点的  1代表从商品点的
          }
          actionsave(obj).then(res => {
            // console.log(response)
            if(res.status){
                vm.$message({
                    message: '加入购物车成功',
                    type: 'success'
                })
                vm.getShopCarData()
            }
          }).catch()
        } else {
            localStorage.setItem('pageUrl', `/${window.location.hash}`);
            vm.$router.push({ name: 'Login' });
        }
      },
      // 展示购物车数据
      async getShopCarData() {
            let data = {
                userId: Cookies.get("UserID"),
            };
            let res = await shoppingCartnum(data)
            if(res.code == '200'){
                this.$store.state.DataStorage.GoodLengthData = res.data;
            }
        },
    },
    components: {
      BottomComponent,
      TopComponent
    }
  }
</script>

<style scoped lang="scss">
  .BookDeatilStyle {
    width: 100%;
    height: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  .BookContainer {
    width: 1200px;
    margin-left: calc(50% - 600px);
    margin-top: 30px;
    margin-bottom: 60px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    padding-top: 20px;
  }

  /* 1 */
  .DivOne {
    height: 180px;
    width: 100%;
    font-size: 0px;
  }

  .leftImg {
    width: 20%;
    height: 100%;
    display: inline-block;
    text-align: center;
    vertical-align: top;
  }

  .leftImg img {
    width: 150px;
    height: 150px;
  }

  .leftImgDiv {
    width: 20%;
    height: 100%;
    display: inline-block;
    text-align: center;
    vertical-align: top;
  }

  .leftImgDiv img {
    width: 150px;
    height: 150px;
  }

  .rightBook {
    width: 50%;
    height: 100%;
    display: inline-block;
    border-bottom: 1px solid rgba(223, 223, 223, 1);
  }

  .rightBook>div {
    margin-top: 10px;
  }

  .booktitle {
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    font-family: PingFangSC-Regular;
  }

  .guancangNumer {
    font-size: 13px;
    color: saddlebrown;
  }

  .bookauthor {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
  }

  .bookPrice {
    color: rgba(255, 18, 18, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
  }
    .tip-wrap{
        position: relative;
    }
    .m-tip{
        font-size:12px;
        position: absolute;
        left: 135px;
        top: 8px;
        color: red;
    }

  .BookButton {
    padding: 0px 15px;
    font-size: 12px;
    border-radius: 4px;
    background-color: rgba(47, 112, 212, 1);
    color: white;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .BookButtonMarc {
    padding: 0px 15px;
    font-size: 12px;
    border-radius: 4px;
    background-color: white;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    color: rgba(47, 112, 212, 1);
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid rgba(47, 112, 212, 1);
    margin-left: 30px;
    cursor: pointer;
  }

  /* 1、2电子书 */
  .DivOneDianzi {
    height: 150px;
    font-size: 0px;
    width: 100%;
    margin-left: 20%;
  }

  .rightBook .dianziBook {
    margin-top: 20px;
  }

  .dianzititle {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
  }

  .dianziPrice {
    color: rgba(255, 18, 18, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }


  /* 2 */
  .DiveTwo {
    height: 200px;
    width: 50%;
    margin-left: 20%;
    border-bottom: 1px solid rgba(223, 223, 223, 1);
    font-size: 0px;
  }

  .DivTwoTitle {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
    padding-top: 30px;
    font-weight: 600;
  }

  .OneInfo {
    width: 40%;
    text-align: left;
    display: inline-block;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .TwoInfo {
    width: 60%;
    text-align: left;
    display: inline-block;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  /* 3 */
  .DiveThree {
    width: 50%;
    margin-left: 20%;
    border-bottom: 1px solid rgba(223, 223, 223, 1);
    padding-bottom: 64px;
  }

  .DivThreeContainer {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  /* MARC */
  .MARCstyle {
    width: 50%;
    margin-left: 20%;
    margin-top: 30px;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .el-table--fit {
    width: 70%;
    margin-left: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Book-DetailSide.vue